/* global swal */
import employeeModalTemplate from 'modals/employeesSearch/index.html';
import EmployeeModalController from 'modals/employeesSearch';
import { merge } from 'lodash';

export default function($log, $uibModal) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;
  vm.activate = activate;

  const emptyNotifications = { email: '', type: 'inHour' };

  /**
   * Takes an notification, validates its information, adds it to the notifications list, and removes it
   * from the newNotifications list.
   *
   */
  vm.addNotification = notification => {
    if (!vm.ngModel) {
      vm.ngModel = [];
    }

    if (!notification.email) return swal('Error', 'Please enter a email');

    if (vm.ngModel.map(({ email }) => email).includes(notification.email)) {
      return swal(
        'Error',
        'This user is already set to receive notification for this event, please enter a unique email address'
      );
    }

    vm.ngModel.push(angular.copy(notification));

    removeNewNotification(notification);
  };

  /**
   * Pops a modal of employees, and adds any that are selected to the new notifications list.
   *
   */
  vm.selectUser = () => {
    const filterEmployees = [];

    $uibModal
      .open({
        backdrop: 'static',
        animation: true,
        template: employeeModalTemplate,
        controller: EmployeeModalController(filterEmployees, true),
        controllerAs: 'employeeModalCtrl'
      })
      .result.then(selectedEmployees => {
        if (!selectedEmployees) return;

        const employees = selectedEmployees.map(({ email }) => ({
          email,
          type: 'inHour'
        }));

        applyNewNotifications(employees);
      })
      .catch(error => {
        if (error === 'backdrop click') return;
        $log.error(error);
        throw error;
      });
  };

  /**
   * Takes selected employees and adds them to the list of new notifications. If an email is
   * already in the new notifications list, it overwrites the current entry.
   *
   * @param {*} selectedEmployees
   */
  function applyNewNotifications(selectedEmployees) {
    selectedEmployees.forEach(employee => {
      let matched = false;

      vm.newNotifications.some(newNotification => {
        const match = newNotification.email === employee.email;

        if (match) {
          merge(newNotification, employee);
          matched = true;
        }

        return match;
      });

      if (!matched) {
        vm.newNotifications.push(employee);
      }
    });
  }

  /**
   * Removes a new emptyNotifications from the new notifications list. If the list has no entries after the
   * operation, it adds an empty notification.
   *
   * @param {*} notification
   */
  function removeNewNotification(notification) {
    vm.newNotifications = vm.newNotifications.filter(({ email }) => email !== notification.email);

    if (vm.newNotifications.length === 0) {
      vm.newNotifications.push(angular.copy(emptyNotifications));
    }
  }

  function activate() {
    $log.debug('Notification Editor Component Activated', vm);

    vm.newNotifications = [angular.copy(emptyNotifications)];
    vm.error = false;
    vm.loaded = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/eventManager/event/notificationsEditor/controller.js